module.exports = __webpack_public_path__ + "img/transformer.e695fca1.jpg";